export const ActorType = {
  HUMAN: 0,
  AI_PROCESS: 1,
  SYSTEM: 2,
};

// The history API sends the actor type by name ("Human"); the numbers are kept for older payloads.
export const ACTOR_TYPE_BY_NAME = {
  Human: ActorType.HUMAN,
  AiProcess: ActorType.AI_PROCESS,
  System: ActorType.SYSTEM,
};

export const AI_ATTRIBUTION_BADGE_LABEL = 'AI';
